module.exports = __webpack_public_path__ + "static/media/ba-home-banner.a18ff05f.png";